<template>
    <div>
        <buttonlist @help="help" @add="add" @search="search" @reflash="reflash" @exps="exps" @save="save"  @del="delall"
                    ref="SetBtn"></buttonlist>
        <ul class="Boxs" ref="Box" :style="{ height: tableHeight + 'px' }">
            <li class="left" ref="left">
				<div class="btnnowrap" style="margin-top: 2px">
                            <el-button type="primary" size="mini" @click="updatecost" :disabled="!btn.updatecost">{{$t('getapi[6436]')}}</el-button>
                        </div>
                <el-tabs :tab-position="'top'" type="" v-model="activeName" @tab-click="selectInfo">
                        <el-tab-pane :label="$t('getapi[4586]')" name="0">
                            <el-table
                                    id="xpane-0"
                                    :data="dataSet"
                                    ref="singleTable"
                                    v-loading="loading"
                                    :highlight-current-row="true"
                                    show-overflow-tooltip="true"
                                    border
                                    stripe
                                    size="mini"
                                    @row-click="editInfo"
                                    @row-dblclick="openEdit"
                                    @selection-change="handleSelectionChange"
                                    :height="tableHeight - reduceTableHeight"
                                    header-row-class-name="headerclass"
                                    style="width: 100%; margin-top:0px"
                            >

                            <el-table-column show-overflow-tooltip prop="Exclusively_ID" :label="$t('getapi[889]')"></el-table-column>
                            <el-table-column prop="Status_Name" :label="$t('getapi[552]')">
                                <template scope="scope">
                                    <span>{{ scope.row.Status_Name | lanchange}}</span>
                                </template>
                            </el-table-column>
                            <el-table-column show-overflow-tooltip prop="Create_person" :label="$t('getapi[3856]')"></el-table-column>
                            <el-table-column prop="Create_date" :label="$t('getapi[3857]')">
                                <template scope="scope">
                                    <span>{{ scope.row.Create_date | toDate}}</span>
                                </template>
                            </el-table-column>
                            <el-table-column show-overflow-tooltip prop="Tab_person" :label="$t('getapi[6437]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Audit_person" :label="$t('getapi[550]')"></el-table-column>
                            <el-table-column prop="Audit_date" :label="$t('getapi[742]')">
                                <template scope="scope">
                                    <span>{{ scope.row.Audit_date | toDate}}</span>
                                </template>
                            </el-table-column>
                            <el-table-column show-overflow-tooltip prop="Department" :label="$t('getapi[1833]')"></el-table-column>
                            </el-table>
                        </el-tab-pane>
                         <el-tab-pane :label="$t('getapi[1422]')" name="1">
                            <el-table
                                    id="xpane-1"
                                    :data="dataSet1"
                                    ref="singleTable1"
                                    v-loading="loading"
                                    :highlight-current-row="true"
                                    show-overflow-tooltip="true"
                                    border
                                    stripe
                                    size="mini"
                                    @row-click="editInfo"
                                    @row-dblclick="openEdit"
                                    @selection-change="handleSelectionChange"
                                    :height="tableHeight - reduceTableHeight"
                                    header-row-class-name="headerclass"
                                    style="width: 100%; margin-top:0px"
                            >
                            <el-table-column show-overflow-tooltip prop="Exclusively_ID" :label="$t('getapi[889]')"></el-table-column>
                            <el-table-column prop="Status_Name" :label="$t('getapi[552]')">
                                <template scope="scope">
                                    <span>{{ scope.row.Status_Name | lanchange}}</span>
                                </template>
                            </el-table-column>
                            <el-table-column show-overflow-tooltip prop="Create_person" :label="$t('getapi[3856]')"></el-table-column>
                            <el-table-column prop="Create_date" :label="$t('getapi[3857]')">
                                <template scope="scope">
                                    <span>{{ scope.row.Create_date | toDate}}</span>
                                </template>
                            </el-table-column>
                            <el-table-column show-overflow-tooltip prop="Tab_person" :label="$t('getapi[6437]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Audit_person" :label="$t('getapi[550]')"></el-table-column>
                            <el-table-column prop="Audit_date" :label="$t('getapi[742]')">
                                <template scope="scope">
                                    <span>{{ scope.row.Audit_date | toDate}}</span>
                                </template>
                            </el-table-column>
                            <el-table-column show-overflow-tooltip prop="Department" :label="$t('getapi[1833]')"></el-table-column>
                            </el-table>
                        </el-tab-pane>
                         <el-tab-pane :label="$t('getapi[2408]')" name="2">
                            <el-table
                                    id="xpane-2"
                                    :data="dataSet2"
                                    ref="singleTable2"
                                    v-loading="loading"
                                    :highlight-current-row="true"
                                    show-overflow-tooltip="true"
                                    border
                                    stripe
                                    size="mini"
                                    @row-click="editInfo"
                                    @row-dblclick="openEdit"
                                    @selection-change="handleSelectionChange"
                                    :height="tableHeight - reduceTableHeight"
                                    header-row-class-name="headerclass"
                                    style="width: 100%; margin-top:0px"
                            >
                            <el-table-column show-overflow-tooltip prop="Exclusively_ID" :label="$t('getapi[889]')"></el-table-column>
                            <el-table-column prop="Status_Name" :label="$t('getapi[552]')">
                                <template scope="scope">
                                    <span>{{ scope.row.Status_Name | lanchange}}</span>
                                </template>
                            </el-table-column>
                            <el-table-column show-overflow-tooltip prop="Create_person" :label="$t('getapi[3856]')"></el-table-column>
                            <el-table-column prop="Create_date" :label="$t('getapi[3857]')">
                                <template scope="scope">
                                    <span>{{ scope.row.Create_date | toDate}}</span>
                                </template>
                            </el-table-column>
                            <el-table-column show-overflow-tooltip prop="Tab_person" :label="$t('getapi[6437]')"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Audit_person" :label="$t('getapi[550]')"></el-table-column>
                            <el-table-column prop="Audit_date" :label="$t('getapi[742]')">
                                <template scope="scope">
                                    <span>{{ scope.row.Audit_date | toDate}}</span>
                                </template>
                            </el-table-column>
                            <el-table-column show-overflow-tooltip prop="Department" :label="$t('getapi[1833]')"></el-table-column>
                            </el-table>
                        </el-tab-pane>
                </el-tabs>
            </li>
            <li class="resize" ref="resize">
                <i class="el-icon-caret-right" @click="leftt(0)"></i>
                <i class="el-icon-caret-left" @click="leftt(1)"></i>
            </li>
            <li class="mid" ref="mid">
                <div  style="float:right;position: relative;">
                    <el-button type="danger" size="mini" icon="el-icon-close" @click="colseEdit"></el-button>
                </div>
                <div>
                    <div class="btnnowrap">
                        <el-button type="primary" size="mini" @click="Audit" :disabled="!btn.audit">{{$t('getapi[941]')}}
                        </el-button>
                    </div>
                    <div style="width:800px;min-width:800px">
                        <table>
                            <tr>
                                <td style="width:80px;min-width:80px"><span>{{$t('getapi[889]')}}</span></td>
                                <td style="width:120px;min-width:120px">
                                    <el-input type="text" size="mini"  v-model="dataDetail.Exclusively_id" :readonly="true" class="readO"></el-input>
                                </td>
                                <td style="width:80px;min-width:80px"><span>{{$t('getapi[552]')}}</span></td>
                                <td style="width:120px;min-width:120px">
                                    <el-input type="text" size="mini" v-if="dataDetail.Status==0" :value="$t('getapi[1422]')"  :readonly="true" class="readO"></el-input>
                                    <el-input type="text" size="mini" v-if="dataDetail.Status==1" :value="$t('getapi[3607]')"  :readonly="true" class="readO"></el-input>
                                </td>
                                <td style="width:80px;min-width:80px"><span>{{$t('getapi[6438]')}}</span></td>
                                <td style="width:120px;min-width:120px">
                                    <el-select filterable popper-class="select-option"
                                               v-model="dataDetail.Department" :disabled="dataDetail.Status!=0"
                                               size="mini">
                                        <el-option v-for="item in DeptList"
                                                   :key="item.Code"
                                                   :label="item.Name"
                                                   :value="item.Name"></el-option>
                                    </el-select>
                                </td>
                                <td style="width:80px;min-width:80px"><span>{{$t('getapi[6439]')}}</span></td>
                                <td style="width:120px;min-width:120px">
                                    <el-input type="text" size="mini" v-model="dataDetail.Tab_person" :readonly="true" class="readO"></el-input>
                                </td>
                            </tr>
                            <tr>
                                <td><span>{{$t('getapi[3856]')}}</span></td>
                                <td>
                                    <el-input type="text" size="mini"  v-model="dataDetail.Create_person"  :readonly="dataDetail.Status==1" :class="{'readO':dataDetail.Status==1}">
                                    </el-input>
                                </td>
                                <td><span>{{$t('getapi[3857]')}}</span></td>
                                <td><el-input type="text" size="mini" v-model="dataDetail.Create_date" :readonly="true" class="readO"></el-input></td>
                            </tr>
                            <tr>
                                <td><span>{{$t('getapi[4043]')}}</span></td>
                                <td>
                                    <el-input type="text" size="mini"  v-model="dataDetail.Audit_person" :readonly="true" class="readO"></el-input>
                                </td>
                                <td><span>{{$t('getapi[4059]')}}</span></td>
                                <td>
                                    <el-input type="text" size="mini" v-model="dataDetail.Audit_date" :readonly="true" class="readO"></el-input>
                                </td>
                                <td><span>{{$t('getapi[733]')}}</span></td>
                                <td>
                                    <el-input type="text" size="mini"  v-model="dataDetail.Update_person" :readonly="true" class="readO"></el-input>
                                </td>
                                <td>
                                    <span>{{$t('getapi[734]')}}</span>
                                </td>
                                <td>
                                    <el-input type="text" size="mini" v-model="dataDetail.Update_date" :readonly="true" class="readO"></el-input>
                                </td>
                            </tr>
                        </table>
                    </div>
                    <!--<div class="box" style="height: 100px;margin-top:5px">
                        <div class="bbl">
                            <span>{{$t('getapi[889]')}}</span>
                            <el-input type="text" size="mini" style="width: 130px;"  v-model="dataDetail.Exclusively_id" :readonly="true" class="readO"></el-input>
                            <span>{{$t('getapi[552]')}}</span>
                            <el-input type="text" size="mini" style="width: 130px;" v-if="dataDetail.Status==0" :value="$t('getapi[1422]')"  :readonly="true" class="readO"></el-input>
                            <el-input type="text" size="mini" style="width: 130px;" v-if="dataDetail.Status==1" :value="$t('getapi[3607]')"  :readonly="true" class="readO"></el-input>
                            <span>{{$t('getapi[6438]')}}</span>
                            <el-select filterable popper-class="select-option" style="width: 130px;"
                            v-model="dataDetail.Department" :disabled="dataDetail.Status!=0"
                            size="mini">
                            <el-option v-for="item in DeptList" 
                            :key="item.Code"
                            :label="item.Name"
                            :value="item.Name"></el-option>
                            </el-select>

                            <span>{{$t('getapi[6439]')}}</span>
                            <el-input type="text" size="mini" style="width: 130px;" v-model="dataDetail.Tab_person" :readonly="true" class="readO"></el-input>
                        </div>
                        <div class="bbl">
                            <span>{{$t('getapi[3856]')}}</span>
                                <el-input type="text" size="mini" style="width: 130px;"  v-model="dataDetail.Create_person"  :readonly="dataDetail.Status==1" :class="{'readO':dataDetail.Status==1}">
                                    
                                </el-input>
                            <span>{{$t('getapi[3857]')}}</span>
                                <el-input type="text" size="mini" style="width: 130px;" v-model="dataDetail.Create_date" :readonly="true" class="readO"></el-input>
                        </div>
						<div class="bbl">
                            <span>{{$t('getapi[4043]')}}</span>
                                <el-input type="text" size="mini" style="width: 130px;"  v-model="dataDetail.Audit_person" :readonly="true" class="readO"></el-input>
                            <span>{{$t('getapi[4059]')}}</span>
                                <el-input type="text" size="mini" style="width: 130px;" v-model="dataDetail.Audit_date" :readonly="true" class="readO"></el-input>
                                <span>{{$t('getapi[733]')}}</span>
                                <el-input type="text" size="mini" style="width: 130px;"  v-model="dataDetail.Update_person" :readonly="true" class="readO"></el-input>
                            <span>{{$t('getapi[734]')}}</span>
                                <el-input type="text" size="mini" style="width: 130px;" v-model="dataDetail.Update_date" :readonly="true" class="readO"></el-input>
                        </div>

                    </div>-->
                    <el-tabs :tab-position="'top'" style="margin-top: 5px" >
                    <el-tab-pane :label="$t('getapi[6440]')" name="0">
                        <div class="btnnowrap">
                            <el-button type="primary"  size="mini" icon="el-icon-circle-plus" @click="addline" :disabled="!btn.addline">{{$t('getapi[878]')}}</el-button>
                            <el-button type="primary"  size="mini" icon="el-icon-delete-solid" @click="delline" :disabled="!btn.deleteline">{{$t('getapi[3886]')}}</el-button>
                        </div>
                        <el-table
                            :data="dataDetail.DTlines"
                            ref="detailTable"
                            v-loading="dloading"
                            :highlight-current-row="true"
                            show-overflow-tooltip="true"
                            border
                            stripe
                            size="mini"
                            :row-class-name="tableRowClassNameM"
                            @selection-change="handleSelectionChangeM"
                            :height="tableHeight - 180"
                            header-row-class-name="headerclass"
                            style="width: 100%; margin-top:2px"
                        >
                            <el-table-column type="selection" v-if="dataDetail.Status == 0"></el-table-column>
                            <el-table-column show-overflow-tooltip prop="Line_no" :label="$t('getapi[1297]')" width="50"></el-table-column>
							<el-table-column show-overflow-tooltip prop="Part_code" :label="$t('getapi[226]')" width="150">
                                 <template slot-scope="scope" >
                                <el-input v-if="IsEdit" class="mcolor"  v-model="scope.row.Part_code" readonly>
                                    <i  class="el-icon-edit el-input__icon" slot="suffix" @click="selectpart(scope)"></i>
                                </el-input>
                                <span v-if="!IsEdit">{{scope.row.Part_code}} </span>
                                </template>

                            </el-table-column>
							<el-table-column show-overflow-tooltip prop="Vender_name" :label="$t('getapi[1197]')">
                                <template slot-scope="scope" >
                                <el-input v-if="dataDetail.Status==0"  v-model="scope.row.Vender_name"  >
                                </el-input>
                                <span v-if="dataDetail.Status==1">{{scope.row.Vender_name}} </span>
                                </template>
                            </el-table-column>
							<el-table-column show-overflow-tooltip prop="Item_code" :label="$t('getapi[876]')"></el-table-column>
							<el-table-column show-overflow-tooltip prop="Standard_cost" :label="$t('getapi[6441]')" align="right" width="100">
                                <template slot-scope="scope" >
                                <el-input type="number" autocomplete="off" title="" @mousewheel.native.prevent v-if="dataDetail.Status==0"  v-model="scope.row.Standard_cost"  width="100">
                                </el-input>
                                <span v-if="dataDetail.Status==1">{{scope.row.Standard_cost}} </span>
                                </template>
                            </el-table-column>
							<el-table-column show-overflow-tooltip prop="Price" :label="$t('getapi[6442]')" align="right">
                                <template slot-scope="scope" >
                                <el-input type="number" autocomplete="off" title="" @mousewheel.native.prevent v-if="dataDetail.Status==0"  v-model="scope.row.Price"  >
                                </el-input>
                                <span v-if="dataDetail.Status==1">{{scope.row.Price}} </span>
                                </template>
                            </el-table-column>
							<el-table-column show-overflow-tooltip prop="New_Standard_cost" :label="$t('getapi[6443]')" align="right" width="100">
                                <template slot-scope="scope" >
                                <el-input type="number" autocomplete="off" title="" @mousewheel.native.prevent v-if="dataDetail.Status==0"  v-model="scope.row.New_Standard_cost"  width="100">
                                </el-input>
                                <span v-if="dataDetail.Status==1">{{scope.row.New_Standard_cost}} </span>
                                </template>
                            </el-table-column>
							<el-table-column show-overflow-tooltip prop="reason" :label="$t('getapi[6444]')">
                                <template slot-scope="scope" >
                                <el-input type="txt" v-if="dataDetail.Status==0"  class="mcolor" v-model="scope.row.reason"  >
                                </el-input>
                                <span v-if="dataDetail.Status==1">{{scope.row.reason}} </span>
                                </template>
                            </el-table-column>
							<el-table-column show-overflow-tooltip prop="Response_person" :label="$t('getapi[6257]')" width="100">
                                <template slot-scope="scope" >
                                <el-input v-if="dataDetail.Status==0" class="mcolor"  v-model="scope.row.Response_person" width="100" readonly>
                                    <i  class="el-icon-edit el-input__icon" slot="suffix" @click="selectemployee(scope)"></i>
                                </el-input>
                                <span v-if="dataDetail.Status==1">{{scope.row.Response_person}} </span>
                                </template>
                            </el-table-column>
							<el-table-column show-overflow-tooltip prop="Remark" :label="$t('getapi[143]')">
                                <template slot-scope="scope" >
                                <el-input v-if="dataDetail.Status==0" v-model="scope.row.Remark"  ></el-input>
                                <span v-if="dataDetail.Status==1">{{scope.row.Remark}} </span>
                                </template>
                            </el-table-column>
							<el-table-column  prop="effective_date" width="130" :label="$t('getapi[548]')">
                                <template slot-scope="scope" >
                            <el-date-picker v-if="dataDetail.Status==0"
                            v-model="scope.row.effective_date"
                            type="date"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            style="width: 130px;"
                            size="mini"
                            ></el-date-picker>
                             <span v-if="dataDetail.Status==1">{{scope.row.effective_date}} </span>
                            </template>
                            </el-table-column>
							<el-table-column  prop="expiry_date" width="130" :label="$t('getapi[549]')">
                                <template slot-scope="scope" >
                            <el-date-picker v-if="dataDetail.Status==0"
                            v-model="scope.row.expiry_date"
                            type="date"
                            value-format="yyyy-MM-dd HH:mm:ss"
                            style="width: 130px;"
                            size="mini"
                            ></el-date-picker>
                             <span v-if="dataDetail.Status==1">{{scope.row.expiry_date}} </span>
                            </template>
                                
                            </el-table-column>

                        </el-table>
                        <!-- <div class="box" style="height: 50px;margin-top:5px">
                        <div class="bbl">
                            <span>订单税额</span>
                            <el-input type="number" size="mini" style="width: 130px;"  :value="orderAPrice | cutZero" :disabled="true"></el-input>
                            <span style="margin-right:10px">订单不含金税额</span>
                            <el-input type="number" size="mini" style="width: 130px;" :value="orderBPrice | cutZero"  :disabled="true"></el-input>
                            <span style="margin-right:10px">订单含税金额</span>
                            <el-input type="number" size="mini" style="width: 130px;" :value="orderCPrice | cutZero" :disabled="true"></el-input>

                        </div>
                         </div> -->

                    </el-tab-pane>
                    

                    </el-tabs>





                </div>
            </li>
        </ul>
        <el-row v-if="SelectIndex == 0" class="page">
        <el-col :span="18">
        <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :page-sizes="[100, 200, 300, 400]"
        :page-size="pageSize"
        :pager-count="5"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        ></el-pagination>
        </el-col>
        <el-col :span="6">
        <div style="text-align: right;line-height: 30px;color: #545c64;font-size: 95%;">{{$t('getapi[7980]')}}:{{ DbTbNames
        }}
        </div>
        </el-col>
        </el-row>
        <el-row v-if="SelectIndex == 1" class="page">
        <el-col :span="18">
        <el-pagination
        @size-change="handleSizeChange1"
        @current-change="handleCurrentChange1"
        :page-sizes="[100, 200, 300, 400]"
        :page-size="pageSize1"
        :pager-count="5"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total1"
        ></el-pagination>
        </el-col>
        <el-col :span="6">
        <div style="text-align: right;line-height: 30px;color: #545c64;font-size: 95%;">{{$t('getapi[7980]')}}:{{ DbTbNames
        }}
        </div>
        </el-col>
        </el-row>
        <el-row v-if="SelectIndex == 2" class="page">
        <el-col :span="18">
        <el-pagination
        @size-change="handleSizeChange2"
        @current-change="handleCurrentChange2"
        :page-sizes="[100, 200, 300, 400]"
        :page-size="pageSize2"
        :pager-count="5"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total2"
        ></el-pagination>
        </el-col>
        <el-col :span="6">
        <div style="text-align: right;line-height: 30px;color: #545c64;font-size: 95%;">{{$t('getapi[7980]')}}:{{ DbTbNames
        }}
        </div>
        </el-col>
        </el-row>
        

        <serce :isVisible="isVisible" queryData="StandardCostExcHeadViewInfo" ref="ser" @getser="serclick"></serce>
        <!-- 选择物料弹框 -->
        <selector :isVisible="false" :isBatch=true :selectType="0" :isSplitPage=true :postUrl="'/Basic/Popup/GetPartPopuDataList'" @callback="getpart" ref="part"></selector>
         <!-- 选择申请人员 -->
        <selector :isBatch=false :isSplitPage=true :selectType="7"
                  :postUrl="'/Basic/Popup/GetEmployeeDataList'"
                  @callback="getemployee" ref="employee"></selector>
      

    </div>
</template>

<script>
import Common from '@/components/Common';
import Array from '@/components/Array';
import CommonHeader from '@/components/CommonHeader';
import { Loading } from 'element-ui';
    export default {
        name: 'standcostapply',
        computed: {
            tableHeight(){
                return this.$windowSize.tableHeight3
            }
        },
        data() {
            return {
                IsEditCode:false,
                visReplacePart:false,
                isVisible: false, // 查询列表是否显示
                queryData: [], // 查询数组
                userData: [], // 用户信息
                DbTbNames: '',
                dataSet: [], // 主表数据
                pageIndex: 1, // 当前页
                pageSize: this.$http.getPageSize('standcostapply'), // 当前页数据量
                total: 0, // 数据总量
                SelectIndex: 0, //当前页面
                oldSelectIndex: 0,
                dataSet1: [], // 主表数据
                pageIndex1: 1, // 当前页
                pageSize1: this.$http.getPageSize('standcostapply1'), // 当前页数据量
                total1: 0, // 数据总量
                dataSet2: [], // 主表数据
                pageIndex2: 1, // 当前页
                pageSize2: this.$http.getPageSize('standcostapply2'), // 当前页数据量
                total2: 0, // 数据总量
                dataSet3: [], // 主表数据
                pageIndex3: 1, // 当前页
                pageSize3: this.$http.getPageSize('standcostapply3'), // 当前页数据量
                total3: 0, // 数据总量
                dataSet4: [], // 主表数据
                pageIndex4: 1, // 当前页
                pageSize4: this.$http.getPageSize('standcostapply4'), // 当前页数据量
                total4: 0, // 数据总量

                dataSet5: [], // 主表数据
                pageIndex5: 1, // 当前页
                pageSize5: this.$http.getPageSize('standcostapply5'), // 当前页数据量
                total5: 0, // 数据总量


                loading: false, // 主表加载状态
                dloading:false,//此表加载状态
                IsEditPrice:false,//是否可以编辑不含税单价
                RStartName:'',//前端缓存外协工序名
                reduceTableHeight: Common.reduceTableHeight1,
                dataDetail:{},
                oldDataDetail:'',
                SignList: [],
                TransList:[],//运输方式
                multipleSelection: [],//左侧主表选择
                multipleSelectionMain: [],
                selectData1: [],
                selectData2: [],
                selectData3: [],
                selectData4: [],
                Line_no:0,
                partindex:0,
                personindex:0,
                IsEdit : true,
                btn:{
                    updatecost:false,
                    audit:false,
					deleteline:false,
                },
                srType: [],//sr类别
                orderDetail: {
                    plancode: '',
                    issrso: '0',
                    isnewflag: '0',
                    sotype: '0',
                    flag: 1,
                    issselfbadflag: '0',
                    iscontinue: 0,
                },
                visOrder: false,
                otherobj:[],//来源跳转页面
                paramobj:[{}],
                orderType: 1,
                orderAPrice:0,//订单税额
                orderBPrice:0,//订单不含税额
                orderCPrice:0,//订单含税额  A+B=C
                DeptList:[],
                activeName: 0,
                oldrow: '',
                iscontinuedblclick: true,
                timeId: null,
                code: '',
                scrollTop:0,
                scrollTop1:0,
                scrollTop2:0,
            };
        },
        watch: {
            dataSet: function () {
                let that = this
                that.$nextTick(function () {
                    that.$processdata.initForm(that.SelectIndex)
                })
            },
            dataSet1: function () {
                let that = this
                that.$nextTick(function () {
                    that.$processdata.initForm(that.SelectIndex)
                })
            },
            dataSet2: function () {
                let that = this
                that.$nextTick(function () {
                    that.$processdata.initForm(that.SelectIndex)
                })
            },
        },
        mounted: function () {
            let that = this;
            that.$processdata.pushModelCache('standcostapply', that)
            that.userData = JSON.parse(sessionStorage.getItem('userData'));
            that.user = that.userData.username;
            //that.dataDetail.Trans_Type
            that.$limits.dragControllerDiv();
            that.confirmAdd()
        },
        created: function(){
            this.DeptList = Array.methods.getDepartmentInfo();
        },
        activated () {
            let that = this
            setTimeout(() => {
                that.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop = res.target.scrollTop
                },false)
                that.$refs.singleTable1.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop1 = res.target.scrollTop
                },false)
                that.$refs.singleTable2.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop2 = res.target.scrollTop
                },false)
            }, 5000);
            // 路由跳转回来滚动到离开时的位置
            this.$nextTick(()=> {
                setTimeout(() => {
                    this.$refs.singleTable.bodyWrapper.scrollTop =this.scrollTop;
                    this.$refs.singleTable1.bodyWrapper.scrollTop =this.scrollTop1;
                    this.$refs.singleTable2.bodyWrapper.scrollTop =this.scrollTop2;
                }, 13)
            })
        },
        methods: {
            help(){
                this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[6552]"),this.$t("getapi[15]"));
            },
            //type 1 一览权限 、2 编辑界面权限
            authority() {
                let that = this;
                if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                    that.$refs.SetBtn.SetOneBtnEnable('help',true);
                }
                if(!this.$limits.menuvisible("plv2", 207, 1)){
                    var value = that.$limits.newOperationAuthorityView('plv2', 206, 1, that.total);
                    that.$refs.SetBtn.SetButtonEnable(value);
                } else {
                    if (that.$limits.authority('plv2', 207, 1) == 1) {
                        //只读权
                        that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                    }
                    if (that.$limits.authority('plv2', 207, 1) == 2) {
                        if (that.$limits.authority('plv3', 207,1) == 0) {
                            that.$refs.SetBtn.SetButtonEnable('search,refresh,export');
                        }
                        //操作权
                        if (that.$limits.authority('plv3', 207,1) == 1) {
                            //编辑级
                            if (that.$limits.fnIsEmpty(that.dataDetail.Exclusively_id))
                            {
                                that.$refs.SetBtn.SetButtonEnable('create,search,save,refresh,export');
                            }
                            else
                            {
                                if(that.dataDetail.Status>0){
                                    that.$refs.SetBtn.SetButtonEnable('create,search,refresh,export');
                                }else{
                                    that.$refs.SetBtn.SetButtonEnable('create,search,save,refresh,export');
                                }


                            }
                        }
                        if (that.$limits.authority('plv3', 207, 1) == 2) {
                            //删除级

                            if (that.$limits.fnIsEmpty(that.dataDetail.Exclusively_id))
                            {
                                that.$refs.SetBtn.SetButtonEnable('create,search,save,refresh,export');
                            }
                            else
                            {
                                if(that.dataDetail.Status>0){
                                    that.$refs.SetBtn.SetButtonEnable('create,search,refresh,export');
                                }else{
                                    that.$refs.SetBtn.SetButtonEnable('create,search,save,del,refresh,export');
                                }
                            }
                        }
                    }
                }
                that.btnauthority();
            },
            btnauthority() {
                let that = this;
                that.btn.addline = false;
				that.btn.deleteline  = false;
				that.btn.updatecost  = true;
				that.btn.audit= false;
				// 0生成   1 审核
				if(that.dataDetail.Status == 0){
				that.btn.deleteline  = true;
				if(that.$limits.authority('plv4', 75, 1) == 1){
                    that.btn.audit= true;
                }
                that.btn.addline=true;
				}else if(that.dataDetail.Status == 1){
				that.btn.deleteline  = false;
				that.btn.audit= false;
                that.btn.addline=false;
				}


            },
            leftt(e) {
                var left = document.getElementsByClassName('left');
                var mid = document.getElementsByClassName('mid');
                var Box = document.getElementsByClassName('Boxs');
                let bw = Box[0].clientWidth;
                if (e == 1) {
                    left[0].style.width = '0px';
                    mid[0].style.width = bw - 13 + 'px';
                } else {
                    left[0].style.width = bw - 50 + 'px';
                    mid[0].style.width = '0px';
                }
            },
            openEdit() {
                let that = this
                clearTimeout(that.timeId)
                if(!that.iscontinuedblclick){
                    return
                }
                let left = document.getElementsByClassName('left');
                let mid = document.getElementsByClassName('mid');
                let Box = document.getElementsByClassName('Boxs');
                let bw = Box[0].clientWidth;
                left[0].style.width = '0px';
                mid[0].style.width = '100%';
            },
            colseEdit(){
                let that = this
                let left = document.getElementsByClassName('left');
                let mid = document.getElementsByClassName('mid');
                let Box = document.getElementsByClassName('Boxs');
                let bw = Box[0].clientWidth;
                left[0].style.width = '100%';
                mid[0].style.width = '0px'
            },
            handleSizeChange(val) {
                this.pageSize = val;
                this.$http.savePageSize('standcostapply',val)
                this.getView();
            },
            handleCurrentChange(val) {
                this.pageIndex = val;
                this.getView();
            },
            handleSizeChange1(val) {
                this.pageSize1 = val;
                this.$http.savePageSize('standcostapply1',val)
                this.getView();
            },
            handleCurrentChange1(val) {
                this.pageIndex1 = val;
                this.getView();
            },
            handleSizeChange2(val) {
                this.pageSize2 = val;
                this.$http.savePageSize('standcostapply2',val)
                this.getView();
            },
            handleCurrentChange2(val) {
                this.pageIndex2 = val;
                this.getView();
            },
            handleSizeChange3(val) {
                this.pageSize3 = val;
                this.$http.savePageSize('standcostapply3',val)
                this.getView();
            },
            handleCurrentChange3(val) {
                this.pageIndex3 = val;
                this.getView();
            },
            handleSizeChange4(val) {
                this.pageSize4 = val;
                this.$http.savePageSize('standcostapply4',val)
                this.getView();
            },
            handleCurrentChange4(val) {
                this.pageIndex4 = val;
                this.getView();
            },
            handleSizeChange5(val) {
                this.pageSize5 = val;
                this.$http.savePageSize('standcostapply5',val)
                this.getView();
            },
            handleCurrentChange5(val) {
                this.pageIndex5 = val;
                this.getView();
            },
            selectInfo(tab, event) {
                let that = this;
                that.activeName = tab.name;
                that.SelectIndex = tab.name;
                that.getView();
                that.$nextTick(function(){
                    that.$processdata.initForm(that.SelectIndex)
                });
            },
            selectemployee(row) {
                let that = this;
                that.personindex = row.$index;
                that.$refs.employee.clearInput(true);
            },
            getemployee(data){
                let that = this;
                console.log(data)
                that.dataDetail.DTlines[that.personindex].Response_person = data.name;           
            },
			//更新标准成本
            updatecost(){
                let that = this;
                let parm={ }
                that.btn.updatecost = false;
                that.$http.urlpost('/Inv/PartCost/InvPartStdCostUpdate', parm, function (res) {
                if (res.Success == 1) {
                that.$message.success(that.$t('getapi[8628]'));//'更新成功！'
                //that.getDetail(that.dataDetail.Exclusively_id)
                }
                });

            },
			Audit(){
				let that = this;
                let parm={
                exclusively_id: that.dataDetail.Exclusively_id,
                update_time:  that.dataDetail.Update_date
                }
                that.btn.audit = false;
                that.$http.urlpost('/Inv/PartCost/StandardCostAudit', parm, function (res) {
                if (res.Success == 1) {
                that.$message.success(that.$t('getapi[1456]'));//'审核成功！'
                that.getDetail(that.dataDetail.Exclusively_id)
                }
                });

			},
            addline() {
                let that = this;
                that.$refs.part.clearInput(true);
                
            },
            //取消下达
            CancelDownOrder(){
                let that = this;

                let parm={
                code: that.dataDetail.Exclusively_ID,
                ids: "",
                update_time:  that.dataDetail.Modify_Date,
                    LangType: that.$processdata.getLang()
                }
                that.btn.cancelassign = false;
                that.$http.urlpost('/ISS/Order/UnExeAudit', parm, function (res) {
                if (res.Success == 1) {
                that.$message.success(that.$t('getapi[8631]'));//'取消下达成功！'
                that.getDetail(that.dataDetail.Exclusively_ID)
                }
                });

            },
            //确认关闭
            CloseOrder(){
                let that = this;
                this.$confirm(that.$t('getapi[8629]'), that.$t('getapi[194]'), {//'你确认要关闭吗?'
                confirmButtonText: that.$t('getapi[1146]'),
                cancelButtonText: that.$t('getapi[2054]'),
                type: 'warning'
                }).then(() => {

                    if(that.$limits.fnIsEmpty(that.dataDetail.Shut_reason)){
                        that.$message.warning(that.$t('getapi[8630]'));////请填写强制关闭原因
                        return;
                    }
                    let parm={
                    code: that.dataDetail.Exclusively_ID,
                    ids: "",
                    update_time:  that.dataDetail.Modify_Date,
                        LangType: that.$processdata.getLang()
                    }
                    that.btn.confirmclose = false;
                    that.$http.urlpost('/ISS/Order/OkClose', parm, function (res) {
                    if (res.Success == 1) {
                    that.$message.success(that.$t('getapi[4230]'));//关闭成功
                    that.getDetail(that.dataDetail.Exclusively_ID)
                    }
                    });
                }).catch(() => {
                // this.$message({
                // type: 'info',
                // message: '已取消删除'
                // });   
                });


                

            },
            //批量设为无效
            setInvalid(){
                let that = this;
                let parm={
                    Code:'',
                };
                for(let i=0;i<that.multipleSelection.length;i++){
                    parm.Code+=that.multipleSelection[i].num+',';

                }
                parm.Code =  parm.Code.substring(0, parm.Code.length - 1);
                that.$http.urlpost('/ISS/PQ/UnISSPQ', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$t('getapi[321]'));//'设置成功！'
                        that.getView();
                        that.getDetail(that.dataDetail.num);//刷右边
                    }
                });
            },
            setClose(){

            },
            setAssign(e) {
                let that = this;
                if(that.$limits.fnIsEmpty(that.dataDetail.Exclusively_ID)){
                    return;
                }

            },
            // 查询
            search() {
                let that = this;
                that.isVisible = true;
                that.$refs.ser.clearInput(that.isVisible, 'StandardCostExcHeadViewInfo');
            },
            //获取查询条件
            serclick(val) {
                this.queryData = val;
                //当前是哪个页面就把哪个置为1
                if (this.SelectIndex == 0) {
                this.pageIndex = 1;
                } else if (this.SelectIndex == 1) {
                this.pageIndex1 = 1;
                } else if (this.SelectIndex == 2) {
                this.pageIndex2 = 1;
                } 
                this.confirmGetView();
            },
            // 确认获取数据
            confirmGetView() {
                let that = this;
                that.pageIndex = 1
                that.isVisible = false;
                that.getView();
            },

            // 数据一览
            getView() {
                let that = this;
                that.loading = true;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let data = {
                    PageIndex: that.pageIndex,
                    PageSize: that.pageSize,
                    SelectIndex: that.SelectIndex,
                    Param: datac
                };
                that.$http.urlpost('/Inv/PartCost/InvPartStdCostExcView', data, function (res) {
                    if (res.Success == 1) {
                        if (that.SelectIndex == 0) {
                            that.dataSet = res.DataContent;
                            that.total = res.Totals;
                        } else if (that.SelectIndex == 1) {
                            that.dataSet1 = res.DataContent;
                            that.total1 = res.Totals;
                        } else if (that.SelectIndex == 2) {
                            that.dataSet2 = res.DataContent;
                            that.total2 = res.Totals;
                        } 
                        that.loading = false;
                        that.DbTbNames = res.DbTbNames;
                    }
                });
            },
            // 根据ID获取详情数据
            editInfo(row) {
                let that = this
                if(that.code == row.Exclusively_ID){
                    return
                }
                if(!this.$limits.menuvisible("plv2", 207, 1)){
                    return
                }
                let datacopy = that.dataDetail
                for(let i = 0;i<datacopy.DTlines.length;i++){
                    delete datacopy.DTlines[i]['index']
                }
                if(that.oldDataDetail != JSON.stringify(datacopy)){
                    that.$confirm(that.$t('getapi[8577]'), that.$t('getapi[194]'), {//'数据已发生变更还未保存，是否切换？'
                        confirmButtonText: that.$t('getapi[2052]'),
                        cancelButtonText: that.$t('getapi[2053]'),
                        closeOnClickModal: false,
                        type: 'warning'
                    })
                        .then(() => {
                            that.oldSelectIndex = that.activeName
                            that.iscontinuedblclick = true
                            that.oldrow = row
                            that.code = row.Exclusively_ID
                            that.getDetail(row.Exclusively_ID);
                        })
                        .catch(() => {
                            that.iscontinuedblclick = false
                            if (that.oldSelectIndex == 0) {
                                that.$refs.singleTable.setCurrentRow(that.oldrow);
                            } else if (that.oldSelectIndex == 1) {
                                that.$refs.singleTable1.setCurrentRow(that.oldrow);
                            } else if (that.oldSelectIndex == 2) {
                                that.$refs.singleTable2.setCurrentRow(that.oldrow);
                            }
                            that.activeName = that.oldSelectIndex
                        });
                } else {
                    that.oldSelectIndex = that.activeName
                    that.iscontinuedblclick = true
                    that.oldrow = row
                    that.code = row.Exclusively_ID
                    that.getDetail(row.Exclusively_ID);
                }
            },
            // 新增
            add() {
                let that = this;
                let datacopy = that.dataDetail
                for(let i = 0;i<datacopy.DTlines.length;i++){
                    delete datacopy.DTlines[i]['index']
                }
                if(that.oldDataDetail != JSON.stringify(datacopy)){
                    that.$confirm(that.$t('getapi[3657]'), that.$t('getapi[194]'), {//'数据已发生变更，是否保存后新建？'
                        confirmButtonText: that.$t('getapi[2052]'),
                        cancelButtonText: that.$t('getapi[2053]'),
                        type: 'warning'
                    })
                        .then(() => {
                            that.save()
                        })
                        .catch(() => {
                            that.openEdit()
                            that.confirmAdd()
                        });
                } else {
                    that.openEdit()
                    that.confirmAdd()
                }
            },
            confirmAdd(){
                let that = this;
                let date = Common.methods.getDate()
                that.code = ''
                that.dataDetail = {
                    DTlines: [],
                    UpdateDate: "",
                    Exclusively_id: "",
                    Status: 0,
                    Create_person: that.user,
                    Create_date: "",
                    Tab_person: that.user,
                    Audit_person: "",
                    Audit_date:"",
                    Department: that.DeptList[0].Name,
                    Update_person: "",
                    Update_date: ""
                }
                that.oldDataDetail = JSON.stringify(that.dataDetail)
                that.authority();
            },
            // 刷新
            reflash() {
                /*let that = this;
                that.getView();
                if(!that.$limits.fnIsEmpty(that.dataDetail.Exclusively_ID)){
                    that.IsEditCode = false;
                    that.dataDetail.IsEdit = 1;
                    that.getDetail(that.dataDetail.Exclusively_ID);
                }*/
                let that = this;
                let datacopy = that.dataDetail
                for(let i = 0;i<datacopy.DTlines.length;i++){
                    delete datacopy.DTlines[i]['index']
                }
                if(that.oldDataDetail != JSON.stringify(datacopy)){
                    that.$confirm(that.$t('getapi[3659]'), that.$t('getapi[194]'), {//'数据已发生变更，是否保存后刷新？'
                        confirmButtonText: that.$t('getapi[2052]'),
                        cancelButtonText: that.$t('getapi[2053]'),
                        type: 'warning'
                    })
                        .then(() => {
                            that.save()
                        })
                        .catch(() => {
                            that.getView();
                            if(!that.$limits.fnIsEmpty(that.dataDetail.Exclusively_id)){
                                that.IsEditCode = false;
                                //that.dataDetail.IsEdit = 1;
                                that.getDetail(that.dataDetail.Exclusively_id);
                            } else {
                                that.confirmAdd()
                            }
                        });
                } else {
                    that.getView();
                    if(!that.$limits.fnIsEmpty(that.dataDetail.Exclusively_id)){
                        that.IsEditCode = false;
                        //that.dataDetail.IsEdit = 1;
                        that.getDetail(that.dataDetail.Exclusively_id);
                    } else {
                        that.confirmAdd()
                    }
                }
            },
            selectpeople(){
                let that = this;
                // if (that.$limits.fnIsEmpty(that.dataDetail.Part_Code)) {
                //     that.$message.warning('请选择物料！');
                //     return;
                // }
                // let param = {
                // part_code: that.dataDetail.Part_Code,
                // part_version: that.dataDetail.Part_Name,
                // PUBPart_ID: that.dataDetail.Part_ID
                // }
                that.$refs.people.clearInput(true);
            },
            //工序信息填写
            getPeople(data){
                let that = this;
                that.dataDetail.Transact_person = data.name;
            },
            
            selectsupplier(){
                let that = this;
                that.$refs.supplier.clearInput(true);
            },
            getsupplier(data){
                let that = this;
                that.dataDetail.Vender_Code = data.vender_code;
                that.dataDetail.Vender_Name = data.vender_name;
                that.dataDetail.Tax_flag = data.tax_flag;
                that.dataDetail.Currency_Code = data.currency_code;
                if(that.$limits.fnIsEmpty(data.vender_code)){
                    that.IsEditPrice = false;
                }else{
                    if(that.dataDetail.Tax_Rate != data.tax_rate){//税率有变化，重新计算
					//不含税价-->含税价
                    that.dataDetail.Tax_Rate = data.tax_rate;
                    let price = that.dataDetail.Net_unit_price * (1 + that.dataDetail.Tax_Rate/100);
                    that.dataDetail.OldUnitPrice = that.dataDetail.Unit_Price;
					that.dataDetail.Unit_Price = price.toFixed(2);
                    }else{
                        that.dataDetail.OldUnitPrice=null;
                    }
                }
                that.IsEditPrice = true;

            },
            CalTaxPrice(e){
                let that =this;
                that.dataDetail.OldUnitPrice = that.dataDetail.Unit_Price;
                let price = e * (1 + that.dataDetail.Tax_Rate/100);
                that.dataDetail.Unit_Price = price.toFixed(2);

            },
            // 批量选择
            handleSelectionChange(val) {
            let that = this;
            that.multipleSelection = val;
            that.btnauthority();
            },
            // 批量选择
            handleSelectionChangeM(val) {
            //let that = this;
            this.multipleSelectionMain = val;
            if(this.multipleSelectionMain.length>0){
                this.btn.mustclose = true;
                if(this.dataDetail.Status == 0)this.btn.deleteline  = true;
                else this.btn.deleteline  = false;
            }else{
                this.btn.mustclose = false;
                this.btn.deleteline  = false;
            }
            },
            tableRowClassName({ row, rowIndex }) {
            row.index = rowIndex;
            },
            tableRowClassNameM({ row, rowIndex }) {
            row.index = rowIndex;
            },
            //删单
            delall(){
                let that = this;
                if(that.$limits.fnIsEmpty(that.dataDetail.Exclusively_id))return;
                let param = {
                exclusively_id: that.dataDetail.Exclusively_id,
                update_time: that.dataDetail.Update_date
                }
                that.$refs.SetBtn.SetOneBtnEnable('del',false);
                that.$http.urlpost('/Inv/PartCost/StandardCostDel', param, function (res) {
                that.$refs.SetBtn.SetOneBtnEnable('del',true);
                if (res.Success == 1) {
                that.reflash();
                that.$message.success(that.$t('getapi[659]'));//'删除成功'
                }
                });


            },
            //删行
            delline() {
            let that = this;
            if(that.multipleSelectionMain.length==0)return;
            if(that.$limits.fnIsEmpty(that.dataDetail.Exclusively_id)){
                // 新建时删除行，不调用接口
                for (let i = that.multipleSelectionMain.length - 1; i >= 0; i--) {
                that.dataDetail.DTlines.splice(that.multipleSelectionMain[i].index, 1);
                }
                return;
            }
            let param = {
            exclusively_id: that.dataDetail.Exclusively_id,
            line_no: "",
            update_time: that.dataDetail.Update_date
            }
            for (let i = that.multipleSelectionMain.length - 1; i >= 0; i--) {
            param.line_no = param.line_no+that.multipleSelectionMain[i].Line_no+',';
            }
            param.line_no = param.line_no.substring(0,param.line_no.length-1);
            that.btn.deleteline = false;
            that.$http.urlpost('/Inv/PartCost/StandardCostLineDel', param, function (res) {
            that.btn.deleteline = true;
            if (res.Success == 1) {
                // for (let i = that.multipleSelectionMain.length - 1; i >= 0; i--) {
                // that.dataDetail.DTlines.splice(that.multipleSelectionMain[i].index, 1);
                // }
                that.$message.success(that.$t('getapi[659]'));//'删除成功'
                that.getDetail(that.dataDetail.Exclusively_id);
            }
            });
            },
            mustclose(){
                let that = this;
                if(that.multipleSelectionMain.length==0){
                    that.$message.warning(that.$t('getapi[8756]'));//"请选择一行数据!"
                    return;
                }
                this.$confirm(that.$t('getapi[8629]'), that.$t('getapi[194]'), {//'你确认要关闭吗?'
                confirmButtonText: that.$t('getapi[1146]'),
                cancelButtonText: that.$t('getapi[2054]'),
                type: 'warning'
                }).then(() => {
                    let param = {
                    code: that.dataDetail.Exclusively_ID,
                    ids: "",
                    update_time: that.dataDetail.Modify_Date
                    }
                    for (let i = that.multipleSelectionMain.length - 1; i >= 0; i--) {
                    param.ids = param.ids+that.multipleSelectionMain[i].Exclusively_ID+',';
                    }
                    param.ids = param.ids.substring(0,param.ids.length-1);
                    param.LangType = that.$processdata.getLang()
                    that.btn.mustclose = false;
                    that.$http.urlpost('/ISS/Order/CloseLines', param, function (res) {
                    that.btn.mustclose = true;
                    if (res.Success == 1) {
                    that.getDetail(that.dataDetail.Exclusively_ID)
                    that.$message.success(that.$t('getapi[4230]'));//关闭成功
                    }
                    });
                }).catch(() => {
                // this.$message({
                // type: 'info',
                // message: '已取消删除'
                // });   
                });


                

            },
            //导入
            imp() {
            let item = {
            //label: '外协价表导入',
            label: '通用导入',
            name: 'exp',
            path: '/exp/12',
            url: '/exp/12',
            icon: 'video-play'
            };
            this.$router.push({ path: '/exp/12' });
            this.$store.commit('selectMenu', item);
            },
            print() {
                //判断状态
                let that = this;
                if(that.$limits.fnIsEmpty(that.dataDetail.Exclusively_ID)){ return; }
                that.$refs.SetBtn.SetOneBtnEnable('print', false);
                that.dloading = true;
                let parm = {
                    po_no: that.dataDetail.Exclusively_ID,
                    HasTaxPrice:that.orderCPrice,
                    TemplateName: '20发外订单.xlsx'
                };
                that.$http.urlpost('/Print/WXPrint', parm, function (res) {
                    that.$refs.SetBtn.SetOneBtnEnable('print', true);
                    if (res.Success == 1) {
                        let hrefurl = res.Key;
                        window.open(hrefurl);
                    } 
                    that.dloading = false;
                });
            },
            // 导出
            exps() {
                let that = this;
                let datac = [];
                for (let i = 0; i < that.queryData.length; i++) {
                    datac.push({
                        query_Condition: that.queryData[i].query_Condition,
                        query_field_type: that.queryData[i].Query_Field_Type,
                        query_field_name: that.queryData[i].Query_Field_Name,
                        query_sort: that.queryData[i].query_sort,
                        row_sign: that.queryData[i].row_sign
                    });
                }
                let parm = {
                    PageIndex: that.PageIndex,
                    PageSize: that.PageSize,
                    SelectIndex: that.SelectIndex,
                    Ids: '',
                    Param: datac,
                    LangType: that.$processdata.getLang(),
                    fromname: that.$t('getapi[987]')
                };
                that.loading = true;
                that.$refs.SetBtn.SetOneBtnEnable('exps',false);
                that.$http.urlpost('/Inv/PartCost/InvPartStdCostExcExportExcel', parm, function (res) {
                    that.$refs.SetBtn.SetOneBtnEnable('exps',true);
                    that.loading = false;
                    if (res.Success == 1) {
                        let hrefurl = Common.Url + res.DataContent.URL;
                        window.open(hrefurl);
                    }
                });
            },
            // 保存
            save() {
                let that = this;
                let parm = that.dataDetail;
                parm.LangType =that.$processdata.getLang()
                for(let i=0;i<parm.DTlines.length;i++){
                    if(that.$limits.fnIsEmpty(parm.DTlines[i].Part_code)){
                        that.$message.warning(that.$t('getapi[252]'));//"物料编码必填!"
                        return;
                    }
                    if(that.$limits.fnIsEmpty(parm.DTlines[i].reason)){
                        that.$message.warning(that.$t('getapi[9750]'));//"异常原因分析必填!"
                        return;
                    }
                    if(that.$limits.fnIsEmpty(parm.DTlines[i].Response_person)){
                        that.$message.warning(that.$t('getapi[9751]'));//"责任人必填!"
                        return;
                    }
                    if(that.$limits.fnIsEmpty(parm.DTlines[i].effective_date)){
                        that.$message.warning(that.$t('getapi[1259]'));//"生效日期必填!"
                        return;
                    }
                    if(that.$limits.fnIsEmpty(parm.DTlines[i].expiry_date)){
                        that.$message.warning(that.$t('getapi[9753]'));//"失效日期必填!"
                        return;
                    }
                }
                that.$refs.SetBtn.SetOneBtnEnable('save', false);
                that.$http.urlpost('/Inv/PartCost/SaveStandardCost', parm, function(res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$t('getapi[3153]'));//'保存成功'
                        //that.dataDetail.IsEdit = 1;
                        that.dataDetail.Exclusively_id = res.UniqueNum;
                        that.getDetail(that.dataDetail.Exclusively_id);
                        that.getView();
                        
                    }
                    that.$refs.SetBtn.SetOneBtnEnable('save', true);
                });
            },
            getDetail(code) {
                let that = this;
                that.dloading = true;
                that.IsEditPrice = true;
                let parm = {
                    Code: code
                };
                clearTimeout(that.timeId)
                that.timeId = setTimeout(() => {
                    let loadingInstance = Loading.service(Common.maskoption);
                    that.$http.urlpost('/Inv/PartCost/GetStandardCostByID', parm, function (res) {
                        if (res.Success == 1) {
                            that.dataDetail = res.DataContent;
                            //that.dataDetail.IsEdit=1;
                            if(that.dataDetail.Status==0)that.IsEdit=true;
                            else that.IsEdit=false;
                            that.dloading = false;
                            if(that.$limits.fnIsEmpty(that.dataDetail.DTlines))that.dataDetail.DTlines=[];
                            // that.dataDetail.Head.relation_mps_line_id = that.dataDetail.Head.relation_mps_line_id.toString()
                            // that.dataDetail.Head.bom_config_flag = that.dataDetail.Head.bom_config_flag.toString()
                            // that.dataDetail.Head.sr_type_id = that.dataDetail.Head.sr_type_id.toString()
                            // that.SignList = that.dataDetail.SignList
                            that.oldDataDetail = JSON.stringify(that.dataDetail)
                            that.authority();
                            that.btnauthority()
                        }
                        loadingInstance.close()
                    });
                }, 100);
            },
            //计算含税不含税价格
            caculateTax(){
            let that = this;
            let Change_Rate = that.dataDetail.huilv;
            that.orderAPrice = 0;//税
            that.orderBPrice = 0;//不含税
            that.orderCPrice = 0;//含税
            if(that.$limits.fnIsEmpty(that.dataDetail.DTlines)){
                return;
            }
            for(let i=0;i<that.dataDetail.DTlines.length;i++){
                let tmqty=0;//数量
                let tmpprice=0;//含税价
                let tmpTaxPrice=0;//不含税价
                let obj = that.dataDetail.DTlines[i];
                if(!that.$limits.fnIsEmpty(obj.Line_Qty)&&!that.$limits.fnIsEmpty(obj.line_total_unitprice)&&!that.$limits.fnIsEmpty(obj.line_net_unitprice)){
                    tmqty = obj.Line_Qty;
                    tmpprice = obj.line_total_unitprice;
                    tmpTaxPrice = obj.line_net_unitprice;
                    that.dataDetail.DTlines[i].line_total_amount = (tmqty*tmpprice).toFixed(4);
                    that.dataDetail.DTlines[i].line_net_amount = (tmqty*tmpTaxPrice).toFixed(4);
                    that.dataDetail.DTlines[i].line_total_amount_cny = (tmqty*tmpprice*Change_Rate).toFixed(4);
                    that.dataDetail.DTlines[i].line_net_amount_cny = (tmqty*tmpTaxPrice*Change_Rate).toFixed(4);

                }
                that.orderCPrice+=tmqty*tmpprice;
                that.orderBPrice+=tmqty*tmpTaxPrice;

            }
            that.orderAPrice = (that.orderCPrice-that.orderBPrice).toFixed(4);
            that.orderBPrice = that.orderBPrice.toFixed(4);
            that.orderCPrice = that.orderCPrice.toFixed(4);
            },
            handleSelectionChange1(val){
                let that = this;
                that.selectData1 = [];
                for (let i = 0; i < val.length; i++) {
                    that.selectData1.push(val[i]);
                }
                that.btnauthority()
            },
            handleSelectionChange2(val){
                let that = this;
                that.selectData2 = [];
                for (let i = 0; i < val.length; i++) {
                    that.selectData2.push(val[i]);
                }
                that.btnauthority()
            },
            handleSelectionChange3(val){
                let that = this;
                that.selectData3 = [];
                for (let i = 0; i < val.length; i++) {
                    that.selectData3.push(val[i]);
                }
                that.btnauthority()
            },
            handleSelectionChange4(val){
                let that = this;
                that.selectData4 = [];
                for (let i = 0; i < val.length; i++) {
                    that.selectData4.push(val[i]);
                }
                that.btnauthority()
            },
            // 生产业务图
            getPro(){
                let that = this
                let data = {}
                if(that.SelectIndex == 0){
                    data = that.selectData[0]
                } else if (that.SelectIndex == 1){
                    data = that.selectData1[0]
                } else if (that.SelectIndex == 2){
                    data = that.selectData2[0]
                } else if (that.SelectIndex == 4){
                    data = that.selectData4[0]
                }
                that.$store.commit('setSharedParams',data);
                let item = {
                    label: '生产关系图',
                    name: 'prorelation',
                    path: '/prorelation/sr',
                    url: '/prorelation/sr',
                    icon: 'video-play'
                };
                this.$router.push({ path: '/prorelation/sr'});
                this.$store.commit('selectMenu', item);
                this.$limits.cachePage(item)
            },
            //批量删除
            batchDel(){
                let that = this
                let arr = []
                if(that.selectData1.length == 0){
                    that.$message.warning(that.$t('getapi[1158]'))//请选择数据！
                    return
                }
                for(let i = 0;i<that.selectData1.length;i++){
                    arr = [...arr,{
                        sr_code: that.selectData1[i].SR_code,
                    }]
                }
                let parm = {
                    Lists: arr
                }
                that.$http.urlpost('/Pro/SR/SRDelLine', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        that.getView()
                    }
                });
            },
            //批量下达
            batchRelease(){
                let that = this
                let arr = []
                if(that.selectData1.length == 0){
                    that.$message.warning(that.$t('getapi[1158]'))//请选择数据！
                    return
                }
                for(let i = 0;i<that.selectData1.length;i++){
                    arr = [...arr,{
                        sr_code: that.selectData1[i].SR_code,
                    }]
                }
                let parm = {
                    Lists: arr
                }
                that.$http.urlpost('/Pro/SR/SRRelease', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        that.getView()
                    }
                });
            },
            //撤销下达
            releaseToCreate(){
                let that = this
                let parm = {
                    sr_code: that.selectData2[0].SR_code
                }
                that.$http.urlpost('/Pro/SR/SRReleaseToCreate', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        that.getView()
                    }
                });
            },
            //取消
            batchCancel(){
                let that = this
                let arr = []
                if(that.selectData2.length == 0){
                    that.$message.warning(that.$t('getapi[1158]'))//请选择数据！
                    return
                }
                for(let i = 0;i<that.selectData2.length;i++){
                    arr = [...arr,{
                        sr_code: that.selectData2[i].SR_code,
                    }]
                }
                let parm = {
                    Lists: arr
                }
                that.$http.urlpost('/Pro/SR/SRBatchCancel', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        that.getView()
                    }
                });
            },
            //生成
            cancelToCreate(){
                let that = this
                let parm = {
                    sr_code: that.selectData4[0].SR_code,
                }
                that.$http.urlpost('/Pro/SR/SRCancelToCreate', parm, function (res) {
                    if (res.Success == 1) {
                        that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                        that.getView()
                    }
                });
            },
            expStatus(val){
              if(val == 0){
                  return '生成'
              } else if(val == 1){
                  return '下达'
              } else if(val == 2){
                  return '已下单'
              } else if(val == 3){
                  return '取消'
              } else {
                  return ''
              }
            },
            del(){
                let that = this;
                this.$confirm(that.$t('getapi[8573]'), that.$t('getapi[194]'), {//'确定删除数据?'
                    confirmButtonText: that.$t('getapi[1146]'),
                    cancelButtonText: that.$t('getapi[2054]'),
                    type: 'warning'
                })
                    .then(() => {
                        let parm = {
                            sr_code : that.dataDetail.Head.sr_code,
                            sr_status:that.dataDetail.Head.sr_status
                        }
                        that.$refs.SetBtn.SetOneBtnEnable('del',false);
                        that.$http.urlpost('/Pro/SR/DelSr', parm, function (res) {
                            that.$refs.SetBtn.SetOneBtnEnable('del',true);
                            if (res.Success == 1) {
                                that.$message.success(that.$processdata.explainCallbackMsg(res.Msg));
                                that.getView()
                                that.confirmAdd()
                            }
                        });
                    })
                    .catch(() => {
                        this.$message({
                            type: 'info',
                            message: that.$t('getapi[8574]')
                        });
                    });
            },
            //获取物料
            selectpart(row) {
                let that = this;
                this.partindex = row.$index;
                that.$refs.part.clearInput(true);
            },
            //委外获取物料弹窗
            selectpartt(){
                let that = this;
                if (that.$limits.fnIsEmpty(that.dataDetail.Part_ID)) {
                    that.$message.warning(this.$t('getapi[8793]'));//'请先选择物料'
                    return;
                }
                let param =  {
                    PUBPart_ID: that.dataDetail.Part_ID
                }
                that.$refs.partt.clearInput(true,param);
            },

            getpart(data){
                let that = this;
                for(let i=0;i<data.length;i++){
                    that.Line_no++;
                    let Relation_IID_Temp=0;
                    if(!that.$limits.fnIsEmpty(that.dataDetail.Exclusively_id)){
                    Relation_IID_Temp = that.dataDetail.Exclusively_id;
                    }
                    let deti = {
                    Relation_id: Relation_IID_Temp.toString(),
                    Line_no: that.dataDetail.DTlines.length+1,
                    Part_code: data[i].part_code,
                    Vender_name: '',
                    Item_code: data[i].item_code,
                    Standard_cost: 0,
                    Price: 0,
                    New_Standard_cost: 0,
                    reason: "",
                    Response_person: "",
                    Remark: "",
                    effective_date: "",
                    expiry_date: ""
                    };
                    //let iidexbefore = 
                    that.dataDetail.DTlines.push(deti);
                }

                //that.dataDetail.DTlines[that.partindex].Part_code = data.part_code;
                //that.dataDetail.DTlines[that.partindex].Item_code = data.item_code;
                
            },
            getSignList(id){
              let that = this
              let parm = {
                  Id: id
              }
                that.$http.urlpost('/Pro/SR/GetSrSignsByPartId', parm, function (res) {
                    if (res.Success == 1) {
                        that.SignList = res.DataContent.DataList
                    }
                });
            },
            selectitem() {
                let that = this;
                that.$refs.item.clearInput(true);
            },
            getitem(data){
                let that = this
                console.log(data)
                that.dataDetail.Head.item_code = data.item_code
            },
            checkDataChange(){
                let that = this
                //如果无保存权限，直接关闭
                if(that.$limits.authority('plv3', 207,1) < 1){
                    return false
                }
                let datacopy = that.dataDetail
                for(let i = 0;i<datacopy.DTlines.length;i++){
                    delete datacopy.DTlines[i]['index']
                }
                let flag =  that.oldDataDetail != JSON.stringify(datacopy)
                return flag
            }
        }
    };
</script>

<style scoped lang="less">
span.title {
	width: 100%;
	display: flex;
	height: 40px;
	line-height: 40px;
}

span.title .el-switch {
	display: inline-block;
	margin: 8px 30px;
}
.box {
	width: 100%;
	overflow-x: auto;
	.bbl {
		margin: 0px auto 10px;
		white-space: pre;
		span {
            margin-left: 10px;
			min-width: 70px;
			text-align: left;
			line-height: 20px;
			display: inline-block;
			margin-right: 0px;
		}
	}
}
    table {
        border-collapse: separate;
        border-spacing: 0px 5px;
        td {
            padding-left: 3px;
            white-space: pre;
        }
    }

    /deep/ .green {
        background: #c8ffbb;
    }
    /deep/ .red {
        background: #ff7879;
    }
</style>
